import React from 'react';
import { Form, Field } from 'react-final-form';
import { Condition } from '@/shared/ui/condition';
import { FormField } from '@/shared/ui/form/form-field';
import { Box } from '@/shared/ui/box';
import { Button } from '@/shared/ui/form/button';
import { Image } from '@/shared/ui/image';
import {
  HeadingRegularQuaternary,
  BodyTextRegularSecondary,
  BodyTextBoldSecondary,
} from '@/shared/ui/typography';

import { useAuth } from '@/features/auth-managment/model/auth-context';
import {
  FormWrapper,
  FormContainer,
  AuthCloseIconImage,
  FormChangeSections,
  ButtonContinue,
} from '@/features/auth-managment/styles';
export const ResetPasswordEmail = () => {
  const {
    resetPasswordMethod,
    setResetPasswordMethod,
    onSubmit,
    spinner,
    t,
    PhoneFieldCmp,
    validateResetPasswordWithEmail,
    validateResetPasswordWithPhone,
    setCurrentStep,
    setAuthenticationType,
    currentStep,
    handleClose,
  } = useAuth();

  return (
    <FormWrapper $currentStep={currentStep}>
      <FormContainer>
        <Box onClick={handleClose}>
          <AuthCloseIconImage
            width={32}
            height={32}
            src="/images/icons/close-dialog.svg"
          />
        </Box>
        <Box $paddingBottom={16} $textAlign="left">
          <HeadingRegularQuaternary>
            {t('auth.reset.title')}
          </HeadingRegularQuaternary>
          <Box $paddingTop={8} />
          <BodyTextRegularSecondary color="#AFAFAF">
            <Condition match={resetPasswordMethod === 'email'}>
              {t('auth.reset.desc')}
            </Condition>
            <Condition match={resetPasswordMethod === 'phone'}>
              {t('auth.reset.desc_phone')}
            </Condition>
          </BodyTextRegularSecondary>
        </Box>
        <FormChangeSections>
          <Button
            onClick={() => setResetPasswordMethod('email')}
            icon={
              <Image
                width={20}
                height={20}
                src="/images/icons/email-icon.svg"
              />
            }
            variant={
              resetPasswordMethod === 'email' ? 'primary' : 'transparent'
            }
          >
            <BodyTextBoldSecondary>
              {t('auth.login.email.button')}
            </BodyTextBoldSecondary>
          </Button>
          <Button
            onClick={() => setResetPasswordMethod('phone')}
            icon={
              <Image
                width={20}
                height={20}
                src="/images/icons/phone-icon.svg"
              />
            }
            variant={
              resetPasswordMethod === 'phone' ? 'primary' : 'transparent'
            }
          >
            <BodyTextBoldSecondary>
              {t('auth.login.phone.button')}
            </BodyTextBoldSecondary>
          </Button>
        </FormChangeSections>
        <Condition match={resetPasswordMethod === 'email'}>
          <Form
            onSubmit={onSubmit}
            validate={validateResetPasswordWithEmail}
            render={({ handleSubmit, submitting }) => (
              <form onSubmit={handleSubmit}>
                <Box $paddingTop={16}>
                  <Field
                    name={'email'}
                    component={FormField}
                    type={'email'}
                    placeholder={t('auth.login.email.placeholder')}
                    label={
                      <BodyTextBoldSecondary>
                        {t('auth.login.email.label')}
                      </BodyTextBoldSecondary>
                    }
                  />
                </Box>
                <Box $paddingTop={24}>
                  <ButtonContinue
                    type="submit"
                    disabled={submitting}
                    isLoading={spinner}
                  >
                    <BodyTextBoldSecondary>
                      {t('auth.reset.submit')}
                    </BodyTextBoldSecondary>
                  </ButtonContinue>
                </Box>
                <Box $paddingTop={12}>
                  <ButtonContinue
                    onClick={() => {
                      setCurrentStep('authorization');
                      setAuthenticationType('signin');
                    }}
                    type="button"
                    variant="secondary"
                  >
                    <BodyTextBoldSecondary>
                      {t('auth.reset.back')}
                    </BodyTextBoldSecondary>
                  </ButtonContinue>
                </Box>
              </form>
            )}
          />
        </Condition>
        <Condition match={resetPasswordMethod === 'phone'}>
          <Form
            onSubmit={onSubmit}
            validate={validateResetPasswordWithPhone}
            render={({ handleSubmit, submitting }) => (
              <form onSubmit={handleSubmit}>
                <Box $paddingTop={16}>
                  <Field
                    name={'phone'}
                    required
                    autoComplete="off"
                    component={PhoneFieldCmp}
                    type={'text'}
                    label={
                      <BodyTextBoldSecondary>
                        {t('auth.login.phone.label')}
                      </BodyTextBoldSecondary>
                    }
                  />
                </Box>
                <Box $paddingTop={24}>
                  <ButtonContinue
                    type="submit"
                    disabled={submitting}
                    isLoading={spinner}
                  >
                    <BodyTextBoldSecondary>
                      {t('auth.reset.submit')}
                    </BodyTextBoldSecondary>
                  </ButtonContinue>
                </Box>
                <Box $paddingTop={12}>
                  <ButtonContinue
                    onClick={() => {
                      setCurrentStep('authorization');
                      setAuthenticationType('signin');
                    }}
                    type="button"
                    variant="secondary"
                  >
                    <BodyTextBoldSecondary>
                      {t('auth.reset.back')}
                    </BodyTextBoldSecondary>
                  </ButtonContinue>
                </Box>
              </form>
            )}
          />
        </Condition>
      </FormContainer>
    </FormWrapper>
  );
};
